import React from 'react';
import { string, func } from 'prop-types';

import classnames from 'classnames';

import useFullFreeshipping from '../hooks/use-full-freeshipping';
import useFullSnackbarState from '../hooks/use-full-snackbar-state';
import FullShippingInfoSkeleton from '../full-shipping-info-skeleton/full-shipping-info-skeleton';
import FullShippingInfoContent from '../full-shipping-info-content/full-shipping-info-content';
import getTypeFromProgressBar from './utils/get-type-from-progress-bar';
import { withComponentHandler } from '../../../hocs/with-component-handler';

const namespace = 'ui-search-fullsnackbar';

const useFullSnackbarProps = (progress_bar, title) => {
  const firstText = title?.first_text?.trim();
  const lastText = title?.last_text?.trim();

  return {
    firstText,
    lastText,
    type: getTypeFromProgressBar(progress_bar),
  };
};

const getSnackbarClassName = (currentClassName, progress_bar, fullOnlyFirstFreeshipping) =>
  classnames(namespace, currentClassName, `ui-search-fullsnackbar--${getTypeFromProgressBar(progress_bar)}`, {
    [`${namespace}--complete-first`]: fullOnlyFirstFreeshipping,
  });

/**
 * Component FullSnackbar
 * @param {Object} props - Props del componente
 * @param {string} [props.className] - Clase CSS adicional para el componente
 * @param {string} [props.variant] - Variante del componente
 * @param {Function} [props.closeAction] - Función para manejar el cierre del snackbar
 * @returns {JSX.Element} Componente de snackbar con información de envío
 */

const FullSnackbar = ({ className, variant, closeAction }) => {
  const {
    currentFullFreeshipping: {
      asset_url,
      className: contextClassName,
      epigraph,
      progress_bar,
      title,
      action_button,
      action_logo,
    },
    isLoading,
  } = useFullFreeshipping();

  const { fullOnlyFirstFreeshipping } = useFullSnackbarState(progress_bar);
  const { firstText, lastText } = useFullSnackbarProps(progress_bar, title);
  const currentClassName = className || contextClassName;

  const contentProps = {
    epigraph,
    progressBar: progress_bar,
    variant,
    assetUrl: asset_url,
    firstText,
    lastText,
    title,
    action_button,
    action_logo,
    showShimmerAction: true,
    closeAction,
  };

  return (
    <div className={getSnackbarClassName(currentClassName, progress_bar, fullOnlyFirstFreeshipping)}>
      {isLoading ? <FullShippingInfoSkeleton /> : <FullShippingInfoContent {...contentProps} />}
    </div>
  );
};

FullSnackbar.propTypes = {
  className: string,
  closeAction: func,
  variant: string,
};

export default withComponentHandler(FullSnackbar, { componentName: 'FullSnackbar' });
